import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const HR = styled.hr`
  height: 2px;
  border: 0;
  margin: 0 auto 20px auto;
  width: 20%;
  color: ${({ $color }) => `var(--color-${$color}, var(--color-black))`};
  background-color: ${({ $backgroundColor }) =>
    `var(--color-${$backgroundColor}, var(--color-black))`};
  &.is-style-default {
    width: 20%;
  }
  &.is-style-wide {
    width: 100% !important;
  }
  &.is-style-dots {
    height: unset !important;
    width: 100% !important;
    display: flex;
    border: 0;
    justify-content: center;
    background-color: transparent !important;
    letter-spacing: 1rem;
    padding-left: 1rem;
    margin: 0;
    &:before {
      content: "· · ·";
      font-size: 40px;
      font-family: Garamond, sans-serif;
      width: 100%;
      display: block;
      text-align: center;
      color: ${({ $color }) => `var(--color-${$color}, var(--color-black))`};
    }
  }
`;

const Separator = ({ className, color, backgroundColor }) => {
  return (
    <HR
      className={className}
      $color={color}
      $backgroundColor={backgroundColor}
    />
  );
};

Separator.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
};

Separator.defaultProps = {
  className: "is-style-default",
  color: "black",
  backgroundColor: "white",
};

export default Separator;
